import React from 'react';
import './styles/loader.scss';

interface LoaderProps {
  size?: string;
}

const FullScreenLoader = ({ size = 'xl' }: LoaderProps) => (
  <div id="chameleon-loader-background" className="container chameleon-loader-background">
    <div className="chameleon-loader">
      <div className={`chameleon-loader-dots-white e2e-chameleon-loader size-${size}`} />
    </div>
  </div>
);

export default FullScreenLoader;
